import React, { useState } from "react";
import "../assets/css/Products.css";
import ContactOptions from "./ContactOptions";

import gaoConnector from "../assets/img/product/gao_connector.jpg";
import gaoSaude from "../assets/img/product/gao_saude.jpg";
import gaoEdu from "../assets/img/product/gao_edu.jpg";
import gaoCms from "../assets/img/product/gao_cms.jpg";
import gaoIa from "../assets/img/product/gao_ia.jpg";
import gaoCity from "../assets/img/product/gao_city.jpeg";

const ProductCard = ({ imgSrc, imgAlt, title, description, href }) => (
  <div className="card card-product d-flex flex-column align-items-start gap-4 color-card-change-orange">
    <div className="container-imagem">
      <img className="container-imagem-size" src={imgSrc} alt={imgAlt} />
    </div>
    <h2 className="title-product">{title}</h2>
    <p className="text-product">{description}</p>
    {href && (
      <a
        className="product-link"
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`Conheça o ${title}`}
      >
        Conheça o projeto <span aria-hidden="true">↗</span>
      </a>
    )}
  </div>
);

const Products = () => {
  const [showModal, setShowModal] = useState(false);

  const handleShow = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  return (
    <div className="d-flex flex-column justify-content-center align-items-center gap-3">
      <div className="container-products d-flex flex-column justify-content-center align-items-center gap-3">
        <div className="text-title-product">
          Nossos Produtos
        </div>
        <button className="bottom-orange z-2" onClick={handleShow}>
          Entre em contato
        </button>
        <div className="row justify-content-center align-items-center gap-3">
          <ProductCard
            imgSrc={gaoCity}
            imgAlt="Painel operacional da plataforma GAO City"
            title="GAO-CITY"
            description="Plataforma inteligente de gestão urbana que conecta cidadãos, equipes de campo e gestores. Centralize chamados, automatize o direcionamento às secretarias e acompanhe serviços, prazos e indicadores em tempo real."
            href="https://gaocity.com.br/"
          />
          <ProductCard
            imgSrc={gaoConnector}
            imgAlt="Conexão"
            title="GAO-CONNECTOR"
            description="Integre seus sistemas e plataformas digitais de forma ágil e simples com o GAO CONNECTOR. Tenha um painel intuitivo para monitorar integrações em tempo real e visualizar a origem e o destino dos dados, garantindo eficiência e transparência nos processos."
          />
          <ProductCard
            imgSrc={gaoSaude}
            imgAlt="Saúde"
            title="GAO-SAÚDE"
            description="Otimize a gestão da sua clínica ou consultório com o GAO SAÚDE. Agendamento de consultas, prontuários médicos e emissão de receitas em uma plataforma única, aumentando a produtividade da equipe e a eficiência do atendimento."
          />
        </div>
        <div className="row justify-content-center align-items-center gap-3">
          <ProductCard
            imgSrc={gaoEdu}
            imgAlt="CMS"
            title="GAO-EDUSAFE"
            description="É uma plataforma para controle de acesso e monitoramento, seu uso é de reconhecimento facial, RFID, QR Code e Biometria, suas notificações são em tempo real para os responsáveis. Com a Dashboard inteligente para administradores educacionais."
          />
          <ProductCard
            imgSrc={gaoCms}
            imgAlt="Conexão"
            title="GAO-CMS"
            description="Simplifique a gestão de atendimentos, compras, contratos e financeiro com o GAO CMS. Com integração para emissão de boletos, automatize processos e melhore a produtividade e o controle financeiro, tudo em uma plataforma centralizada."
          />
          <ProductCard
            imgSrc={gaoIa}
            imgAlt="Saúde"
            title="GAO-SISTEMA IA"
            description="Sistema de Multi-atendimento de com, múltiplos canais e usuários, com integração dos modelos de inteligência artificial. "
          />
        </div>
      </div>
      <div id="history-container"></div>
      <ContactOptions show={showModal} handleClose={handleClose} />
    </div>
  );
};

export default Products;
